import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link} from 'react-router-dom';
import Register from './Register';
import Login from './Login';
import Profile from './Profile';
import ProtectedRoute from './ProtectedRoute';
import WeeklySchedule from './WeeklySchedule';
import AdminTokenAdjuster from './AdminTokenAdjuster';
//import Leaderboard from './Leaderboard';//
import WeeklyStandings from './WeeklyStandings';
import './App.css';
import Footer from './footer';
import axios from 'axios';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
// import Snowfall from 'react-snowfall';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userTokens, setUserTokens] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false); // State to store admin status
  const [leagueNumber, setLeagueNumber] = useState(null); // Assuming leagueNumber is part of your state

  useEffect(() => {
    const checkLoginStatusAndFetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        setIsLoggedIn(true);
        try {
          const profileResponse = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/profile`, // <-- updated here
            {
              headers: { Authorization: `Bearer ${token}` }
            }
          );
          setUserTokens(profileResponse.data.tokens);
          setIsAdmin(profileResponse.data.is_admin); // Set isAdmin state from profile data
          setLeagueNumber(profileResponse.data.league_number);

        } catch (error) {
          console.error('Error fetching user data:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          setIsLoggedIn(false);
          setUserTokens(0);
          setIsAdmin(false); // Reset isAdmin on error
        }
      } else {
        setIsLoggedIn(false);
        setUserTokens(0);
        setIsAdmin(false); // Reset isAdmin if not logged in
      }
    };

    checkLoginStatusAndFetchUserData();
  }, [isLoggedIn]); // Add isLoggedIn as a dependency


  const onLoginSuccess = () => {
    setIsLoggedIn(true);
    // useEffect will fetch data including admin status
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    setIsLoggedIn(false);
    setUserTokens(0);
    setIsAdmin(false); // Reset isAdmin on logout
    window.location.reload();
  };

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <div className="app-title">
            <Link to="/"><h2>Weekly Pickem</h2></Link>
            <span className="material-symbols-outlined">
              check
            </span>
          </div>
          <nav className="app-nav">
            <ul>
              <li>
                <Link id="home-link" to="/">Home</Link>
              </li>
              {isLoggedIn ? (
                <>
                  <li>
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li>
                    {leagueNumber === 1 && (
                      <span>Tokens: {userTokens}</span>
                    )}
                  </li>
                   {/* Conditionally render Admin link if user is admin */}
                   {isAdmin && ( // <-- Conditional rendering here
                      <li>
                         <Link to="/admin/adjust-tokens">Admin</Link>
                      </li>
                   )}
                  <li>
                    <button onClick={handleLogout}>Logout</button>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link to="/register">Register</Link>
                  </li>
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                </>
              )}
            </ul>
          </nav>
        </header>

        <main>
          <Routes>
            <Route path="/login" element={<Login onLoginSuccess={onLoginSuccess} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route
              path="/admin/adjust-tokens"
              element={
                <ProtectedRoute>
                   {/* Optional: Add a frontend check to redirect non-admins */}
                   {/* {isAdmin ? <AdminTokenAdjuster /> : <Navigate to="/" replace />} */}
                  <AdminTokenAdjuster /> {/* Currently only protected by login status */}
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <div className="welcome-container">
                  <div className='welcome-bg'>
                  <h2>Weekly Pickem</h2>
                  <p className="subheader">Try to guess as many correct outcomes as possible! Check your
                     Profile page for your all time correct guesses!
                  </p>
                  </div>
                  {/* <Snowfall color="#82C3D9" snowflakeCount="250"/> */}
                  <WeeklySchedule />
                  <WeeklyStandings />
                  {/* <Leaderboard /> */}

                  {isLoggedIn ? (
                    <p></p>
                  ) : (
                    <p></p>
                  )}
                </div>

              }
            />

          </Routes>

        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

